import { AcquaintanceTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/AcquaintanceTypeCodesEnum';
import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import { DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { KNM_SUBJECT_IS_EXIST_AT_ACT_ERROR, REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { makeIsNormalInteger } from 'CorePackage/MainModule/validators/isNormalInteger';
import { makeNoSoonerThenValidator } from 'CorePackage/MainModule/validators/isNoSoonerThan';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import {
  getViolatedMandatoryRequirementsValidator,
  makeRequiredArray,
} from 'KnmErknmPackage/MainModule/common/violatedMandatoryRequirementsValidator';
import { ActTypesEnum } from 'KnmErknmPackage/ErknmActsModule/enums';
import { AcquaintanceLackTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/AcquaintanceLackTypeCodesEnum';
import { KnmSubjectTypesEnum } from 'KnmErknmPackage/ErknmSubjectModule/components/ErknmSubjectInfo';
import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { IDictionaryKnmKindSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryKnmKindSelectOption';
import { IKnmPmFormRescheduling } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormRescheduling';
import { makeNoLaterThenValidator } from 'CorePackage/MainModule/validators/isNoLaterThen';

import { IKnmErknmFormOrganizationAdd } from '../interfaces/IKnmErknmFormOrganizationAdd';
import { IKnmErknmFormSubject } from '../interfaces/IKnmErknmFormSubject';
import { IKnmErknmFormAct } from '../interfaces/IKnmErknmFormAct';
import { getErknmActEventsValidate } from './getErknmActEventsValidate';
import { IKnmErknmFormRescheduling } from '../interfaces/IKnmErknmFormRescheduling';
import { IKnmErknmFormInspector } from '../interfaces/IKnmErknmFormInspector';
import { IKnmErknmFormEvent } from '../interfaces/IKnmErknmFormEvent';
import { makeRequiredQuillEditorDelta } from '../../../CorePackage/MainModule/validators/isRequiredQuillEditorDelta';
import { getActRemarksValidate } from './getActRemarksValidate';
import { KNO_INSPECTORS_KNM_LABEL, makeSignerInInspectorsValidator } from './getSignerInInspectorsError';

interface IGetErknmActsValidateProps {
  organizations: IKnmErknmFormSubject[] | undefined;
  acts: IKnmErknmFormAct[] | undefined;
  getOrganizationValidate: (
    item: IKnmErknmFormSubject | IKnmErknmFormOrganizationAdd,
    errorMsg: string | undefined,
    orgs: IKnmErknmFormSubject[] | IKnmErknmFormOrganizationAdd[] | undefined,
  ) => FormErrors<IKnmErknmFormSubject>;
  isShow4127: boolean;
  isShow22: boolean;
  startDate: string | undefined;
  kindKnm: IDictionaryKnmKindSelectOption | undefined;
  isKnmStatusTypeCarriedOut: boolean | undefined;
  isKnmStatusTypeCompleted: boolean | undefined;
  isValidateRequiredViolatedMandatory: boolean;
  isViolationsStartDate: boolean;
  isLaterThanFieldsMarksSetting: boolean;
  isInteractionCategoryOrInspectorRequired: boolean | undefined;
  rescheduling: (IKnmErknmFormRescheduling[] & IKnmPmFormRescheduling[]) | null | undefined;
  inspectorsErknm: IKnmErknmFormInspector[] | undefined;
  stopDate: string | undefined;
  isValidateActionStartDateInKnmAct: boolean;
  isProsecutorOrSuperProsecutor: boolean | undefined;
  isKnmStatusApproving: boolean | undefined;
  isKindCodeRO: boolean;
  eventsErknm?: IKnmErknmFormEvent[] | undefined;
  isEnablePaperlessDocument?: boolean;
  isRepeatValidationChecking: boolean;
}

export const getErknmActsValidate = ({
  organizations,
  acts,
  getOrganizationValidate,
  isShow4127,
  isShow22,
  startDate,
  kindKnm,
  isKnmStatusTypeCarriedOut,
  isKnmStatusTypeCompleted,
  isValidateRequiredViolatedMandatory,
  isViolationsStartDate,
  isLaterThanFieldsMarksSetting,
  isInteractionCategoryOrInspectorRequired,
  inspectorsErknm,
  isKnmStatusApproving,
  isProsecutorOrSuperProsecutor,
  isValidateActionStartDateInKnmAct,
  rescheduling,
  stopDate,
  isKindCodeRO,
  eventsErknm,
  // isEnablePaperlessDocument,
  isRepeatValidationChecking,
}: IGetErknmActsValidateProps) => {
  let actOrganization: IKnmErknmFormOrganizationAdd[] | undefined = [];

  if (organizations) {
    actOrganization = [...organizations];
  }

  acts?.forEach(i => {
    if (i.organization) {
      actOrganization?.push(i.organization);
    }
  });

  return acts?.map(item => {
    const isAcquaintanceExtended = item.acquaintanceType?.code === AcquaintanceTypeCodesEnum.ACQ_TYPE_I;
    const isAcquaintanceUnextended = item.acquaintanceType?.code === AcquaintanceTypeCodesEnum.ACQ_TYPE_II;
    const isAcquaintanceLackExtended = item.acquaintanceLackType?.code === AcquaintanceLackTypeCodesEnum.ACQ_TYPE_I;
    const isOrganizationFiz = item.organization?.subjectType?.label === KnmSubjectTypesEnum.FIZ;
    const isOrganizationNotRegisteredIur =
      item.organization?.subjectType?.label === KnmSubjectTypesEnum.IUR &&
      item.organization.isForeignSubjectAgencyNotRegistredInRf;

    let organizationValidate;

    if (item.organization && (item.typeAct?.id === 1 || (item.typeAct?.id === 2 && isKindCodeRO && item.paperless))) {
      const defaultOrgValidate = getOrganizationValidate(
        item.organization,
        KNM_SUBJECT_IS_EXIST_AT_ACT_ERROR,
        actOrganization,
      );

      organizationValidate = {
        ...defaultOrgValidate,
        country: isOrganizationNotRegisteredIur
          ? makeRequired('Поле не может быть пустым')(item.organization.country)
          : undefined,
      };

      if (isOrganizationFiz || isOrganizationNotRegisteredIur) {
        organizationValidate.organizationName = makeRequired('Поле не может быть пустым')(
          item.organization.organizationName,
        );
      }
    }

    let knoInspectors:
      | string
      | (string | undefined)[]
      | { fullName: string | undefined; position: string | undefined }[]
      | { knoInspector: string | undefined }[]
      | undefined =
      isShow4127 && (!item.knoInspectors || item.knoInspectors?.length === 0) ? 'Поле не может быть пустым' : undefined;

    if (item.typeAct?.id === ActTypesEnum.KNM_ACT_IMPOSSIBLE) {
      knoInspectors = undefined;
    } else if (item.knoInspectors && item.knoInspectors?.length !== 0) {
      let errors:
        | (string | undefined)[]
        | { fullName: string | undefined; position: string | undefined }[]
        | { knoInspector: string | undefined }[];

      if (isShow22) {
        errors = item.knoInspectors?.map(knoInspector => {
          return { knoInspector: makeRequired('Поле не может быть пустым')(knoInspector?.knoInspector) };
        });
      } else {
        errors = item.knoInspectors?.map(knoInspector => {
          return {
            fullName: makeRequired('Поле не может быть пустым')(knoInspector.fullName),
            position: makeRequired('Поле не может быть пустым')(knoInspector.position),
          };
        });
      }

      // @ts-ignore
      if (errors.filter(i => i).length) {
        knoInspectors = errors;
      } else {
        knoInspectors = undefined;
      }
    }

    let holdingDateTime: string | undefined;
    let durationDays: string | undefined;
    let durationHours: string | undefined;

    if (item.typeAct?.id === ActTypesEnum.KNM_ACT) {
      if (item.paperless) {
        holdingDateTime = composeValidators(
          makeRequired(REQUIRED_ERROR),
          makeNoSoonerThenValidator(
            'Дата и время начала проведения КНМ не должно быть раньше даты начала проведения КНМ',
            () => startDate,
          ),
          makeNoLaterThenValidator(
            'Дата и время начала проведения КНМ не должно быть позже даты окончания проведения КНМ',
            () => stopDate,
          ),
        )(item.holdingDateTime ? item.holdingDateTime.split(' ')[0] : item.holdingDateTime);
        durationDays = composeValidators(
          makeRequired(REQUIRED_ERROR),
          makeIsNormalInteger('Введены недопустимые символы'),
        )(item.durationDays);
        durationHours = composeValidators(
          makeRequired(REQUIRED_ERROR),
          makeIsNormalInteger('Введены недопустимые символы'),
        )(item.durationHours);
      } else {
        if (item.holdingDateTime) {
          holdingDateTime = makeNoSoonerThenValidator(
            'Дата и время начала проведения КНМ не должны быть раньше даты начала проведения КНМ',
            () => startDate,
            DATE_FORMAT_LONG_MINUTE_FNS,
          )(item.holdingDateTime);
        }
        durationDays = makeIsNormalInteger('Введены недопустимые символы')(item.durationDays);
        durationHours = makeIsNormalInteger('Введены недопустимые символы')(item.durationHours);
      }
    }

    return {
      document: item.paperless
        ? undefined
        : {
            attachments: makeRequired(REQUIRED_ERROR)(item.document?.attachments),
          },
      typeAct: makeRequired(REQUIRED_ERROR)(item.typeAct),
      canceledReason:
        item.typeAct?.id === ActTypesEnum.KNM_ACT_IMPOSSIBLE
          ? makeRequired(REQUIRED_ERROR)(item.canceledReason)
          : undefined,
      canceledReasonDescription:
        item.paperless && item.typeAct?.id === ActTypesEnum.KNM_ACT_IMPOSSIBLE
          ? makeRequired(REQUIRED_ERROR)(item.canceledReasonDescription)
          : undefined,
      canceledReasonDescriptionReactQuillEditor:
        item.paperless && item.typeAct?.id === ActTypesEnum.KNM_ACT_IMPOSSIBLE
          ? makeRequiredQuillEditorDelta(REQUIRED_ERROR)(item.canceledReasonDescriptionReactQuillEditor)
          : undefined,
      creationActDateTime:
        item.creationActDateTime && item.typeAct?.id !== ActTypesEnum.KNM_ACT_IMPOSSIBLE
          ? makeNoSoonerThenValidator(
              'Дата и время составления акта КНМ не должны быть раньше даты начала проведения КНМ',
              () => startDate,
              DATE_FORMAT_LONG_MINUTE_FNS,
            )(item.creationActDateTime)
          : undefined,
      holdingDateTime,
      durationDays,
      durationHours,
      organizationTemplate:
        item.typeAct?.id === ActTypesEnum.KNM_ACT && kindKnm?.code === KnmKindCodesEnum.RO
          ? makeRequired(REQUIRED_ERROR)(item.organizationTemplate)
          : undefined,
      organization: organizationValidate,
      knoInspectors,
      fioAndPositionSinger:
        (item.paperless || (isShow4127 && item.typeAct?.id === ActTypesEnum.KNM_ACT)) && !item.systemSignatureUsed
          ? composeValidators(
              makeRequired('Поле не может быть пустым'),
              makeSignerInInspectorsValidator(item.knoInspectors, KNO_INSPECTORS_KNM_LABEL),
            )(item.fioAndPositionSinger?.value.fullName)
          : undefined,
      acquaintanceType:
        !item.paperless && isShow22 && item.typeAct?.id !== ActTypesEnum.KNM_ACT_IMPOSSIBLE
          ? makeRequired('Поле не может быть пустым')(item.acquaintanceType)
          : undefined,
      fioReader: isAcquaintanceExtended ? makeRequired('Поле не может быть пустым')(item.fioReader) : undefined,
      titleReader: isAcquaintanceExtended ? makeRequired('Поле не может быть пустым')(item.titleReader) : undefined,
      fioSigner:
        !item.paperless && !isShow4127 && isAcquaintanceExtended
          ? makeRequired('Поле не может быть пустым')(item.fioSigner)
          : undefined,
      titleSigner:
        !item.paperless && !isShow4127 && isAcquaintanceExtended
          ? makeRequired('Поле не может быть пустым')(item.titleSigner)
          : undefined,
      refuserFio: isAcquaintanceLackExtended ? makeRequired('Поле не может быть пустым')(item.refuserFio) : undefined,
      refuserTitle: isAcquaintanceLackExtended
        ? makeRequired('Поле не может быть пустым')(item.refuserTitle)
        : undefined,
      acquaintanceLackType:
        isShow22 && isAcquaintanceUnextended
          ? makeRequired('Поле не может быть пустым')(item.acquaintanceLackType)
          : undefined,
      isViolatedMandatoryRequirements:
        (isKnmStatusTypeCarriedOut || isKnmStatusTypeCompleted) && item.typeAct?.id === ActTypesEnum.KNM_ACT
          ? makeRequired('Поле не может быть пустым')(item.isViolatedMandatoryRequirements)
          : undefined,
      violatedMandatoryRequirements:
        (isKnmStatusTypeCarriedOut || isKnmStatusTypeCompleted) && item.isViolatedMandatoryRequirements?.value === true
          ? composeValidators(
              makeRequiredArray('Поле не может быть пустым'),
              getViolatedMandatoryRequirementsValidator({
                isSigned: item.paperless ? item.signed : undefined,
                isValidateRequiredViolatedMandatory,
                isDecisionMode: false,
                isProdReady: isViolationsStartDate,
                isRepeatValidationChecking,
              }),
            )(item.violatedMandatoryRequirements)
          : undefined,
      events:
        (isKnmStatusTypeCompleted || isKnmStatusTypeCarriedOut) && item.typeAct?.id === ActTypesEnum.KNM_ACT
          ? getErknmActEventsValidate({
              events: item.events,
              holdingDateTime: item.holdingDateTime,
              isInteractionCategoryOrInspectorRequired,
              isPaperless: item.paperless,
              inspectorsErknm,
              isKnmStatusApproving,
              isKnmStatusTypeCompleted,
              isProsecutorOrSuperProsecutor,
              isShow22,
              isValidateActionStartDateInKnmAct,
              rescheduling,
              startDate,
              stopDate,
              eventsMain: eventsErknm,
            })
          : undefined,
      isViolationResolvedNote:
        isLaterThanFieldsMarksSetting && item.isViolationResolved?.value
          ? makeRequired(REQUIRED_ERROR)(item.isViolationResolvedNote)
          : undefined,
      involvedExperts:
        item.paperless && item.involvedExperts?.length
          ? item.involvedExperts.map(expert => ({
              expert: makeRequired(REQUIRED_ERROR)(expert.expert),
            }))
          : undefined,
      involvedWitnesses:
        item.paperless && item.involvedWitnesses?.length
          ? item.involvedWitnesses.map(witnesses => ({
              fullName: makeRequired(REQUIRED_ERROR)(witnesses.fullName),
            }))
          : undefined,
      familiarizationNotifications: item?.familiarizationNotifications?.map(fn => ({
        knmNoticeType: makeRequired(REQUIRED_ERROR)(fn?.knmNoticeType),
        noticeDate: makeRequired(REQUIRED_ERROR)(fn?.noticeDate),
      })),
      remarks: getActRemarksValidate(item?.remarks),
    };
  });
};
